import React from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";

let _cache = null;
export function fetchGlossaryTerms() {
  if (!_cache) _cache = api.get("/glossary").then((r) => r.data).catch(() => []);
  return _cache;
}

// Build a matcher: case-insensitive, longest-term-first, whole-word.
export function makeGlossaryCtx(terms) {
  if (!terms || !terms.length) return null;
  const sorted = [...terms].sort((a, b) => b.term.length - a.term.length);
  const alt = sorted.map((t) => t.term.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")).join("|");
  return {
    re: new RegExp(`\\b(${alt})\\b`, "i"),
    map: Object.fromEntries(sorted.map((t) => [t.term.toLowerCase(), t.slug])),
  };
}

// Linkify the FIRST occurrence of each glossary term (tracked in `used`) → array of nodes.
export function linkifyNodes(text, ctx, used) {
  if (!ctx) return [text];
  const nodes = [];
  let rest = text;
  let guard = 0;
  while (rest && guard++ < 200) {
    const m = ctx.re.exec(rest);
    if (!m) { nodes.push(rest); break; }
    const term = m[1];
    const key = term.toLowerCase();
    const slug = ctx.map[key];
    const end = m.index + term.length;
    if (used.has(key) || !slug) {
      nodes.push(rest.slice(0, end));
      rest = rest.slice(end);
      continue;
    }
    used.add(key);
    if (m.index) nodes.push(rest.slice(0, m.index));
    nodes.push(
      <Link key={`gl-${key}`} to={`/glossary#${slug}`}
        className="text-teal underline decoration-rose/60 underline-offset-2 hover:decoration-teal">
        {term}
      </Link>
    );
    rest = rest.slice(end);
  }
  return nodes;
}

// Plain-text renderer with glossary links (for forum posts / replies).
export function GlossaryText({ text, terms, className = "" }) {
  const ctx = React.useMemo(() => makeGlossaryCtx(terms), [terms]);
  const used = new Set();
  return <div className={className}>{linkifyNodes(text || "", ctx, used)}</div>;
}
